import React from "react";
import { Col, Row } from "react-bootstrap";
import RouterUtils from "../../utils/RouterUtils.js";
import useShowLoader from "../common/loading-widgets/useShowLoader.js";
import useTranslationAuthenticationUi from "./useTranslationAuthenticationUi.js";
import ActionButton from "../common/widgets/ActionButton.js";
import * as ROUTES from "../../constants/routes.js";
import Banner from "./Banner.js";
import "./ConnectionMode.scss";
import useReferrer from "../infra-no-ui/navigation/useReferrer.js";

export default function ConnectionMode() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();
  const {redirectTo} = useReferrer();

  useShowLoader(tLoading, "ConnectionMode");
  if (tLoading) return null;

  function onClickRecruiterSignIn(event) {
    event.preventDefault();
    RouterUtils.openExternalUrl(ROUTES.RECRUITER_SIGN_IN);
  }

  const onClickSignIn = (event) => {
    event.preventDefault();
    redirectTo(ROUTES.SIGN_IN, false);
  };
  return (
    <div className="connection-mode-div">
      <Row>
        <Col className="sign-in-action-col-container">
          <Row>
            <Col>
              <ActionButton className="sign-in-action" onClick={onClickSignIn}>
                {t("authentication-ui:sign_in_with_employer")}
              </ActionButton>
            </Col>
          </Row>
          <Row>
            <Col>
              <ActionButton
                className="sign-in-action-recruiter"
                onClick={(event) => onClickRecruiterSignIn(event)}
              >
                {t("authentication-ui:sign_in_with_recruiter")}
              </ActionButton>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Banner />
        </Col>
      </Row>
    </div>
  );
}
